exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pi-cname[data-v-0c822eeb]{display:inline}.pi-cname__link[data-v-0c822eeb]:focus{outline:2px solid #1b59f8;outline-offset:2px}.pi-cname__shard[data-v-0c822eeb]{margin-left:6px;font-size:11px;font-weight:400;color:#6b7280;white-space:nowrap}.pi-cname__shard.is-stacked[data-v-0c822eeb]{display:block;margin:2px 0 0}.pi-cname__demo[data-v-0c822eeb]{margin-left:6px;vertical-align:baseline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c822eeb","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/vue/pages/components/pi/piCompanyName.vue
// module id = 1624
// module chunks = 0